import { get, post } from '@web3/base-utils';
import { baseApiUrl, walletApiUrl } from '@/config/api';

export default {
  // 资产 - 去中心化
  getMyLpTokenSumV3(
    params:
      | {
          walletAddresses: { walletAddress: string; chainId?: number }[];
          walletType?: number;
        }
      | any
  ) {
    return post(`${baseApiUrl}/v3/account/sum`, params);
  },

  // 资产 - 中心化
  getMyLpTokenSum(walletAddr: string | any) {
    return get(`${baseApiUrl}/v2/account/sum`, { walletAddr });
  },

  // coin 信息
  getCoinsInfo(chainCode: string, contractAddresses: string[]) {
    return get(`${walletApiUrl}/coins/info`, {
      chainCode,
      contractAddresses: contractAddresses.join(','),
    });
  },

  // 币种价格
  getQuote(chainCode: string, contractAddresses: string[]) {
    return get(`${walletApiUrl}/coins/usd/price`, {
      chainCode,
      contractAddresses: contractAddresses.join(','),
    });
  },

  // 主页配置信息-不需要登录态 - https://uponly.larksuite.com/wiki/TxDJwnlKFiAy9BkctdOuPbuCsue
  getV3HomeConfig() {
    return get(`${baseApiUrl}/v3/home/config`);
  },
};
